export const SEARCH_LIST_DEFAULT_SORTING_TYPE = 'auctionStartDate-ASCENDING'
